import { useLanguage } from "@/i18n";
import Reveal from "@/components/Reveal";

const IMG_PLATE = "https://images.pexels.com/photos/8251356/pexels-photo-8251356.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_PALAPA = "https://images.pexels.com/photos/20717940/pexels-photo-20717940.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_COCORICO = "https://images.pexels.com/photos/9313901/pexels-photo-9313901.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_POLAR = "https://images.pexels.com/photos/611315/pexels-photo-611315.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_COCKTAIL = "https://images.pexels.com/photos/33239322/pexels-photo-33239322.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_SWIM = "https://images.pexels.com/photos/31475647/pexels-photo-31475647.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_DJ = "https://images.pexels.com/photos/10099363/pexels-photo-10099363.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Included() {
  const { t } = useLanguage();
  const items = t.included.items;
  const images = { "01": IMG_PLATE, "02": IMG_PALAPA, "03": IMG_COCKTAIL, "04": IMG_COCORICO, "05": IMG_DJ, "06": IMG_SWIM, "07": IMG_POLAR };

  const span = (tag) =>
    tag === "01" ? "md:col-span-4 md:row-span-2 min-h-[22rem]"
    : tag === "07" ? "md:col-span-6 min-h-[12rem]"
    : "md:col-span-2 min-h-[11rem]";

  return (
    <section id="included" data-testid="included-section" className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-ocean mb-4">{t.included.kicker}</p>
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-lg">{t.included.title}</h2>
          <div className="text-right">
            <span className="font-display text-5xl sm:text-6xl font-extrabold text-sunset" data-testid="included-price">{t.included.price}</span>
            <p className="text-xs font-mono uppercase tracking-widest text-slate-400">{t.included.per}</p>
          </div>
        </div>
      </Reveal>

      <div className="grid md:grid-cols-6 gap-4 [grid-auto-flow:dense]">
        {items.map((item, i) => (
          <Reveal key={item.tag} delay={i * 0.07} className={span(item.tag)}>
            <div data-testid={`included-tile-${item.tag}`}
              className="group relative h-full rounded-2xl border border-stroke bg-surface overflow-hidden hover:border-sunset/50 transition-colors duration-500">
              {images[item.tag] && (
                <>
                  <img src={images[item.tag]} alt={item.title}
                    className="absolute inset-0 w-full h-full object-cover opacity-85 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-night/95 via-night/25 to-transparent" />
                </>
              )}
              <div className="relative h-full flex flex-col justify-end p-6">
                <span className="font-mono text-[11px] tracking-widest text-ocean mb-2">{item.tag}</span>
                <h3 className="font-display text-lg sm:text-xl font-bold">{item.title}</h3>
                <p className="text-sm text-slate-400 mt-1.5 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p className="mt-8 text-sm text-slate-400 italic" data-testid="included-extras">+ {t.included.extras}</p>
      </Reveal>
    </section>
  );
}
